export async function loadExternalConnectInteraction(engine, refresh = true) {
    await engine.addInteractor("externalConnect", async (container) => {
        const { Connector } = await import("./Connector.js");
        return new Connector(container);
    }, refresh);
}
export * from "./Options/Classes/Connect.js";
export * from "./Options/Classes/ConnectLinks.js";
export * from "./Options/Interfaces/IConnect.js";
export * from "./Options/Interfaces/IConnectLinks.js";
